import { app } from '../../../../../app';
import { Controller } from './edit-profile.controller';

app.component('editCorporateProfile', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./edit-profile.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/corporate-settings/company-profile/edit-profile/edit-profile.component.js